if (typeof ShippingCalculator !== 'function') {
  class ShippingCalculator extends HTMLElement {
    constructor() {
      super();

      const estimateShipping = this.querySelector('.js-estimate-shipping');
      const country = this.querySelector('[name="country"]');
      const province = this.querySelector('[name="province"]');
      const zip = this.querySelector('[name="zip"]');
      const resultsBlock = this.querySelector('.shipping-estimator__results');
      const resultsBlockContent = this.querySelector('.shipping-estimator__results-content');
      const resultsBlockContentList = this.querySelector('.shipping-estimator__results-content-list');
      const resultsBlockContentHeading = this.querySelector('.shipping-estimator__results-content-heading');
      const resultsErrors = this.querySelector('.alert');
      const deliveryDetails = document.createElement('div');
      deliveryDetails.id = 'delivery-details';

      const shippingRateMapping = {
        'Canada Post Tracked Packet International': [4, 7],
        'Canada Post Xpresspost': [1, 2],
        'Canada Post Expedited Parcel': [1, 3],
        'Canada Post Priority': [1, 1],
        'Canada Post Expedited Parcel USA': [4, 8],
        'Canada Post Tracked Packet USA': [4, 8],
        'Canada Post Xpresspost USA': [2, 5],
        // Add extra rates here as needed [mindate, maxdate]
      };

      const rateCategories = {
        'British Columbia': [1, 1],
        'Alberta': [1, 2],
        'Saskatchewan': [2, 3],
        'Manitoba': [3, 4], 
        'Ontario': [4, 5], 
        'Quebec': [5, 6], 
        'Eastern Provinces': [6, 8], 
        'Northern Territories': [7, 14], 
        
        // Added placeholders for new rates
        'Manitoba Xpresspost': [2, 4], 
        'Ontario Xpresspost': [3, 3], 
        'Quebec Xpresspost': [3, 3], 
        'Eastern Provinces Xpresspost': [4, 4], 
        'Northern Territories Xpresspost': [5, 5], 
        'Alberta Priority': [2, 2], 
        'Saskatchewan Priority': [2, 2], 
        'Manitoba Priority': [2, 2], 
        'Ontario Priority': [2, 2], 
        'Eastern Provinces Priority': [4, 4],
        'Northern Territories Priority': [4, 4], 
      };

      this.shippingRateMapping = shippingRateMapping;
      this.rateCategories = rateCategories;

      setTimeout(() => {
        new Shopify.CountryProvinceSelector('shipping-estimator-country', 'shipping-estimator-province', {
          hideElement: 'address_province_container'
        });
      });

      estimateShipping.addEventListener('click', e => {
        e.preventDefault();

        resultsBlockContentList.innerHTML = "";
        deliveryDetails.innerHTML = "";

        fetch("".concat(KROWN.settings.routes.cart_url, "/shipping_rates.json?shipping_address[zip]=").concat(zip.value, "&shipping_address[country]=").concat(country.value, "&shipping_address[province]=").concat(province.value), {
          credentials: 'same-origin',
          method: 'GET'
        }).then(response => {
          response.json().then(result => {
            if (result.country || result.zip) {
              resultsBlockContent.style.display = "none";
              resultsBlock.style.display = "block";
              resultsErrors.style.display = "block";
              resultsErrors.innerHTML = "";

              Object.keys(result).forEach(key => {
                resultsErrors.innerHTML += `<li>${result[key]}</li>`;
              });

            } else {
              const rates = result.shipping_rates;

              resultsErrors.style.display = "none";
              resultsBlock.style.display = "block";
              resultsBlockContent.style.display = "block";

              if (rates.length === 1) {
                resultsBlockContentHeading.innerHTML = KROWN.settings.locales.shipping_calculator_results_heading_one;
              } else {
                resultsBlockContentHeading.innerHTML = KROWN.settings.locales.shipping_calculator_results_heading_multiple;
              }

              rates.forEach((rate, index) => {
                let deliveryDays;
                if (country.value === 'Canada') {
                  const deliveryType = this._getDeliveryType(country.value, province.value);
                  deliveryDays = this.shippingRateMapping[rate.name].map(day => day + this.rateCategories[deliveryType][0]);
                } else {
                  deliveryDays = this.shippingRateMapping[rate.name];
                }
                const deliveryDate = this._calculateDeliveryDate(deliveryDays);
                resultsBlockContentList.innerHTML += `
                  <div class="shipping-estimator__radio-button">
                    <input type="radio" id="shipping-rate-${index}" name="shipping-rate" value="${rate.name}" data-delivery-start="${deliveryDate.start}" data-delivery-end="${deliveryDate.end}">
                    <label for="shipping-rate-${index}">${rate.name}: ${this._formatMoney(rate.price, KROWN.settings.shop_money_format)}</label>
                  </div>`;
              });

              // Add the deliveryDetails div after the radio buttons and before the calendar
              resultsBlockContentList.insertAdjacentElement('afterend', deliveryDetails);

              // Add event listeners to radio buttons
              const radioButtons = resultsBlockContentList.querySelectorAll('input[type="radio"]');
              radioButtons.forEach(radioButton => {
                radioButton.addEventListener('change', (e) => {
                  const startDate = new Date(e.target.dataset.deliveryStart);
                  const endDate = new Date(e.target.dataset.deliveryEnd);
                  const rateName = e.target.value;
                  this._updateCalendar(startDate, endDate);
                  deliveryDetails.innerHTML = `${rateName} estimated delivery date: ${endDate.toDateString()}`;
                });
              });
            }
          }).catch(error => {
            console.error('Error parsing response JSON:', error);
          });
        }).catch(error => {
          console.error('Error fetching shipping rates:', error);
        });
      });

      country.addEventListener('change', () => {
        resultsBlock.style.display = "none";
      });
    }

    _formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    _calculateDeliveryDate(daysArray) {
      console.log('Calculating delivery date with days:', daysArray);

      if (!Array.isArray(daysArray) || daysArray.length !== 2 || isNaN(daysArray[0]) || isNaN(daysArray[1])) {
        console.error('Invalid delivery days:', daysArray);
        return { start: 'Invalid Date', end: 'Invalid Date' };
      }

      const currentDate = new Date();
      const startDate = this._addBusinessDays(currentDate, parseInt(daysArray[0], 10));
      const endDate = this._addBusinessDays(currentDate, parseInt(daysArray[1], 10));

      return {
        start: this._formatDate(startDate),
        end: this._formatDate(endDate)
      };
    }

        _addBusinessDays(date, days) {
      let count = 0;
      let newDate = new Date(date);
      while (count < days) {
        newDate.setDate(newDate.getDate() + 1);
        // Skip weekends
        if (newDate.getDay() !== 0 && newDate.getDay() !== 6) {
          count++;
        }
      }
      return newDate;
    }

    _formatDate(date) {
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    }

    _getDeliveryType(country, province) {
      console.log(`Country: ${country}, Province: ${province}`); // Debugging line

      // Assuming the store is located in British Columbia (BC), Canada
      if (country !== 'Canada') {
        return 'national';
      }

      // Specific rate categories for each province
      const provinces = {
        'British Columbia': 'British Columbia',
        'Alberta': 'Alberta',
        'Saskatchewan': 'Saskatchewan',
        'Manitoba': 'Manitoba',
        'Ontario': 'Ontario',
        'Quebec': 'Quebec',
        'New Brunswick': 'Eastern Provinces',
        'Newfoundland and Labrador': 'Eastern Provinces',
        'Nova Scotia': 'Eastern Provinces',
        'Prince Edward Island': 'Eastern Provinces',
        'Yukon': 'Northern Territories',
        'Northwest Territories': 'Northern Territories',
        'Nunavut': 'Northern Territories'
      };

      return provinces[province] || 'national';
    }

    _updateCalendar(startDate, endDate) {
      $("#delivery-calendar").datepicker("destroy");
      $("#delivery-calendar").datepicker({
        beforeShowDay: function (date) {
          if (date.getDay() === 0 || date.getDay() === 6) {
            return [false, "", "Unavailable"];
          }
          if (date >= startDate && date <= endDate) {
            return [true, "highlight"];
          }
          return [true, ""];
        }
      });
      $("#delivery-calendar").datepicker("setDate", this._adjustForWeekend(endDate));
    }

    _adjustForWeekend(date) {
      const day = date.getDay();
      if (day === 6) { // Saturday
        date.setDate(date.getDate() + 2);
      } else if (day === 0) { // Sunday
        date.setDate(date.getDate() + 1);
      }
      return date;
    }
  }

  if (typeof customElements.get('shipping-calculator') == 'undefined') {
    customElements.define('shipping-calculator', ShippingCalculator);
  }
}